<template>
  <div
    class="score"
    :style="cssVars"
    v-bind="$attrs"
  >
    <span>{{ scoreDisplayed }}</span>
  </div>
</template>

<script>
export default {
  name: 'Score',
  props: {
    score: {
      type: Number,
      default: null,
    },
    maxScore: {
      type: Number,
      default: 100,
    },
    short: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    hasScore() {
      return this.score !== null;
    },
    scoreDisplayed() {
      if (this.short && this.score) {
        return this.score.toFixed(0);
      }

      return !this.hasScore ? 'DNP' : parseFloat(this.score.toFixed(1));
    },
    backgroundColor() {
      if (!this.hasScore) {
        return '#4E5059';
      } if (this.score >= (75 * this.maxScore) / 100) {
        return '#33CE78';
      } if (this.score >= (60 * this.maxScore) / 100) {
        return '#70DBC6';
      } if (this.score >= (45 * this.maxScore) / 100) {
        return '#C2DB2E';
      } if (this.score >= (30 * this.maxScore) / 100) {
        return '#F0CE1D';
      } if (this.score >= (15 * this.maxScore) / 100) {
        return '#F7AA38';
      }

      return '#FF9999';
    },
    sizeStyle() {
      switch (this.size) {
        case 'xlg': return { fontSize: 22, minWidth: 56, minHeight: 36};
        case 'lg': return { fontSize: 18, minWidth: 46, minHeight: 30};
        case 'sm': return { fontSize: 10, minWidth: 28, minHeight: 18};
        default: return { fontSize: 14, minWidth: 38, minHeight: 24};
      }
    },
    cssVars() {
      return {
        '--bg-color': this.color ?? this.backgroundColor,
        '--color': !this.hasScore || this.color ? '#EFEFE8' : '#161C30',
        '--font-size': `${this.sizeStyle.fontSize}px`,
        '--line-height': `${this.sizeStyle.fontSize}px`,
        '--min-height': `${this.sizeStyle.minHeight}px`,
        '--min-width': `${this.sizeStyle.minWidth}px`,
      }
    },
  },
};
</script>

<style scoped lang="scss">
.score {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  font-weight: bold;
  border-radius: 20px !important;
  background-color: var(--bg-color);
  color: var(--color);
  min-height: var(--min-height);
  min-width: var(--min-width);
  font-size: var(--font-size);
  line-height: var(--line-height);
}

</style>
